// Common headers for all requests
const commonHeaders = {
  "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json",
  "Accept": "text/javascript",
};

/**
 * A reusable fetch API method with support for different data types
 * @param {string} url - The API endpoint
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {Object} data - The request payload (optional)
 * @param {string} dataType - The expected response type (json, text, blob, script, etc.)
 * @returns {Promise} - The response from the API
 */
export const fetchAPI = async (url, method = "GET", data = null, dataType = "script") => {
  let finalUrl = url;
  
  // Adjust headers based on dataType
  const requestHeaders = { ...commonHeaders };
  requestHeaders["Accept"] = dataType === "json" ? "application/json" : "text/javascript";

  // Append GET parameters to URL
  if (method === "GET" && data) {
    const params = new URLSearchParams(data).toString();
    finalUrl = `${url}?${params}`;
  }

  const options = {
    method,
    headers: requestHeaders,
    credentials: 'same-origin', // Ensures cookies are sent with the request
  };

  // Add body for non-GET requests
  if (data && method !== "GET") {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(finalUrl, options);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Handle different response types
    switch (dataType) {
      case "script": {
        const scriptText = await response.text();
        // For script responses, we evaluate them directly in the global context
        // This is how Rails handles remote: true behavior
        eval.call(window, scriptText);
        return scriptText; // Return for debugging purposes
      }
      case "json":
        return await response.json();
      case "text":
        return await response.text();
      case "blob":
        return await response.blob();
      default:
        throw new Error(`Unsupported dataType: ${dataType}`);
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
window.fetchAPI = fetchAPI;